const TranslatedColumn = (t: (s: string) => string, context?: string) => (params: any) => {
    return t(params.cell.value);
};

export default TranslatedColumn;
